import { useUiText } from "../../locale/UiLocale";
import type { ReactNode } from "react";
import { Icon } from "../../icons";
import { IconButton } from "../IconButton/IconButton";
import type { Density } from "./DataTableTypes";

/** The bar above the table: search, filter pills and tools, in that order. */
export function DataTableToolbar({ children }: { children: ReactNode }): React.JSX.Element {
  return <div className="nb-dt-toolbar">{children}</div>;
}

interface DataTableSearchProps {
  query: string;
  placeholder: string;
  onQueryChange: (query: string) => void;
}

export function DataTableSearch({ query, placeholder, onQueryChange }: DataTableSearchProps): React.JSX.Element {
  return (
    <div className="nb-input-wrap nb-dt-search">
      <Icon name="search" className="nb-input-icon" />
      <input
        className="nb-input nb-input-sm"
        type="search"
        value={query}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e) => onQueryChange(e.target.value)}
      />
    </div>
  );
}

/** Right side of the toolbar: the caller's extra controls, then the table's own tools. */
export function DataTableTools({ extra, children }: { extra: ReactNode; children: ReactNode }): React.JSX.Element {
  return (
    <div className="nb-dt-tools">
      {extra ? <div className="nb-dt-extra">{extra}</div> : null}
      {children}
    </div>
  );
}

/** Switches between comfortable and compact rows; labelled with the view it switches to. */
export function DensityButton({ density, onToggle }: { density: Density; onToggle: () => void }): React.JSX.Element {
  const t = useUiText();
  const compact = density === "compact";
  return (
    <IconButton
      label={compact ? t("Comfortable view") : t("Compact view")}
      icon={compact ? "rows" : "density"}
      aria-pressed={compact}
      onClick={onToggle}
    />
  );
}
